export default __webpack_public_path__ + "static/media/creative-tim-white-slim2.1d2bb67c.png";